import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "baseui/modal";
import { Button } from "baseui/button";
import { Select, Value } from "baseui/select";
import { styled } from "baseui";

interface BusinessData {
  id: string;
  name: string;
  logo_url?: string;
}

interface BusinessSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  businesses: BusinessData[];
  onBusinessSelect: (businessId: string) => void;
}

const ModalContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',
  maxWidth: '400px',
});

export const BusinessSelectionModal = ({
  isOpen,
  onClose,
  businesses,
  onBusinessSelect,
}: BusinessSelectionModalProps) => {
  const [selectedBusiness, setSelectedBusiness] = useState<Value>([]);
  
  // Preselect first business if available
  useEffect(() => {
    if (isOpen && businesses.length > 0 && selectedBusiness.length === 0) {
      setSelectedBusiness([{
        id: businesses[0].id,
        label: businesses[0].name
      }]);
    }
  }, [isOpen, businesses, selectedBusiness.length]);
  
  const handleSubmit = () => {
    if (selectedBusiness.length > 0 && selectedBusiness[0].id) {
      const businessId = selectedBusiness[0].id.toString();
      onBusinessSelect(businessId);
    } else if (businesses.length > 0) {
      // Fallback to first business if somehow nothing is selected
      onBusinessSelect(businesses[0].id);
    }
  };
  
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeable={false}
      animate
      size="default"
      role="dialog"
      autoFocus
              overrides={{
          Dialog: {
            style: {
              width: '500px',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              borderBottomLeftRadius: '8px',
              borderBottomRightRadius: '8px',
              zIndex: 9999
            }
          }
        }}
    >
      <ModalHeader>Select Business</ModalHeader>
      <ModalBody>
        <ModalContent>
          <p>Your account has access to multiple businesses. Please select the business you want to access:</p>
          
          <Select
            options={businesses.map(business => ({
              id: business.id,
              label: business.name
            }))}
            value={selectedBusiness}
            placeholder="Select a business"
            onChange={params => {
              setSelectedBusiness(params.value);
            }}
            clearable={false}
            autoFocus
            overrides={{
              ControlContainer: {
                style: {
                  borderRadius: '4px'
                }
              },
              Popover: {
                props: {
                  overrides: {
                    Body: {
                      style: {
                        zIndex: '999999 !important',
                      },
                    },
                  },
                },
              },
              Dropdown: {
                style: {
                  zIndex: '999999 !important',
                },
              },
            }}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleSubmit} disabled={selectedBusiness.length === 0}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
}; 